/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ActivateSignatureApproverDto = {
  /**
   * UUID of approver
   */
  id: string;
  /**
   * Status of the approver
   */
  status: ActivateSignatureApproverDto.status;
  /**
   * Approval link URI
   */
  approval_link: string | null;
  /**
   * Approval link expiration date
   */
  approval_link_expiration_date: string | null;
};
export namespace ActivateSignatureApproverDto {
  /**
   * Status of the approver
   */
  export enum status {
    APPROVED = 'approved',
    INITIATED = 'initiated',
    NOTIFIED = 'notified',
    REJECTED = 'rejected',
  }
}
